import React, { } from 'react'
import { Checkbox } from '@mui/material'
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';



const ProfileInfo = ({ setInputs, inputs }) => {



	const handleOnChange = (input: string, value: any) => {
		setInputs((prevState: any) => ({
			...prevState,
			[input]: value,
		}));
	};

	return (
		<div  >
			{/* CheckBox */}
			<div className='Job_Description_Header'>
				<div className="AddJob_main_ProfileInfo">
					<div className="AddJob_main_ProfileInfo_sub">
						<div className="AddJob_main_Profile_sub">
							<Checkbox
								icon={<CheckBoxOutlineBlankIcon style={{ color: "#0275B1", border: 1 }} />}
								checkedIcon={<CheckBoxIcon style={{ color: "#0275B1", border: 1 }} />}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 40,
										borderRadius: 50,
									}
								}}

								checked={inputs.firstname}
							/>

						</div>
						<div className="AddJob_main_Profile_sub2">First Name</div>
					</div>
					<div>

						<input
							type="checkbox"
							id="toggle-firstname"
							className="toggle__checkbox"
							checked={inputs.firstname}
							onChange={(e) => handleOnChange("firstname", e.target.checked)}
						/>
						<label htmlFor="toggle-firstname" className="toggle__wrap  toggle__circle">
							<label htmlFor="toggle-firstname" className="toggle__label  toggle__circle  toggle__text"></label>
						</label>
					</div>
				</div>
				<div className="AddJob_main_ProfileInfo">
					<div className="AddJob_main_ProfileInfo_sub">
						<div className="AddJob_main_Profile_sub">
							<Checkbox
								icon={<CheckBoxOutlineBlankIcon style={{ color: "#0275B1", border: 1 }} />}
								checkedIcon={<CheckBoxIcon style={{ color: "#0275B1", border: 1 }} />}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 40,
										borderRadius: 50,
									}
								}}
								checked={inputs.lastname}
							/>

						</div>
						<div className="AddJob_main_Profile_sub2">Last Name</div>
					</div>
					<div>
						<input type="checkbox"
							id="toggle-lastname"
							className="toggle__checkbox"
							checked={inputs.lastname}
							onChange={(e) => handleOnChange("lastname", e.target.checked)}
						/>
						<label htmlFor="toggle-lastname" className="toggle__wrap  toggle__circle">
							<label htmlFor="toggle-lastname" className="toggle__label  toggle__circle  toggle__text"></label>
						</label>
					</div>
				</div>

				<div className="AddJob_main_ProfileInfo">
					<div className="AddJob_main_ProfileInfo_sub">
						<div className="AddJob_main_Profile_sub">
							<Checkbox
								icon={<CheckBoxOutlineBlankIcon style={{ color: "#0275B1", border: 1 }} />}
								checkedIcon={<CheckBoxIcon style={{ color: "#0275B1", border: 1 }} />}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 40,
										borderRadius: 50,
									}
								}}
								checked={inputs.email}
							/>

						</div>
						<div className="AddJob_main_Profile_sub2">Email</div>
					</div>
					<div>
						<input type="checkbox" name="" id="toggle-email"
							className="toggle__checkbox"
							checked={inputs.email}
							onChange={(e) => handleOnChange("email", e.target.checked)}
						/>
						<label htmlFor="toggle-email" className="toggle__wrap  toggle__circle">
							<label htmlFor="toggle-email" className="toggle__label  toggle__circle  toggle__text"></label>
						</label>
					</div>
				</div>
				<div className="AddJob_main_ProfileInfo">
					<div className="AddJob_main_ProfileInfo_sub">
						<div className="AddJob_main_Profile_sub">
							<Checkbox
								icon={<CheckBoxOutlineBlankIcon style={{ color: "#0275B1", border: 1 }} />}
								checkedIcon={<CheckBoxIcon style={{ color: "#0275B1", border: 1 }} />}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 40,
										borderRadius: 50,
									}
								}}
								checked={inputs.resume} />

						</div>
						<div className="AddJob_main_Profile_sub2">Resume</div>
					</div>
					<div>
						<input type="checkbox" id="toggle-resume"
							className="toggle__checkbox"
							checked={inputs.resume}
							onChange={(e) => handleOnChange("resume", e.target.checked)} />
						<label htmlFor="toggle-resume" className="toggle__wrap  toggle__circle">
							<label htmlFor="toggle-resume" className="toggle__label  toggle__circle  toggle__text"></label>
						</label>
					</div>
				</div>
				<div className="AddJob_main_ProfileInfo">
					<div className="AddJob_main_ProfileInfo_sub">
						<div className="AddJob_main_Profile_sub">
							<Checkbox
								icon={<CheckBoxOutlineBlankIcon style={{ color: "#0275B1", border: 1 }} />}
								checkedIcon={<CheckBoxIcon style={{ color: "#0275B1", border: 1 }} />}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 40,
										borderRadius: 50,
									}
								}}
								checked={inputs.linkedinUrl}
							/>

						</div>
						<div className="AddJob_main_Profile_sub2">LinkedIn Url</div>
					</div>
					<div>
						<input type="checkbox" id="toggle-linkedinurl" className="toggle__checkbox"
							checked={inputs.linkedinUrl}
							onChange={(e) => handleOnChange("linkedinUrl", e.target.checked)} />
						<label htmlFor="toggle-linkedinurl" className="toggle__wrap  toggle__circle">
							<label htmlFor="toggle-linkedinurl" className="toggle__label  toggle__circle  toggle__text"></label>
						</label>
					</div>
				</div>
				<div className="AddJob_main_ProfileInfo">
					<div className="AddJob_main_ProfileInfo_sub">
						<div className="AddJob_main_Profile_sub">
							<Checkbox
								icon={<CheckBoxOutlineBlankIcon style={{ color: "#0275B1", border: 1 }} />}
								checkedIcon={<CheckBoxIcon style={{ color: "#0275B1", border: 1 }} />}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 40,
										borderRadius: 50,
									}
								}}
								checked={inputs.Phone} />

						</div>
						<div className="AddJob_main_Profile_sub2">Phone</div>
					</div>
					<div>
						<input type="checkbox" id="toggle-phone" className="toggle__checkbox"
							checked={inputs.Phone}
							onChange={(e) => handleOnChange("Phone", e.target.checked)} />
						<label htmlFor="toggle-phone" className="toggle__wrap  toggle__circle">
							<label htmlFor="toggle-phone" className="toggle__label  toggle__circle  toggle__text"></label>
						</label>
					</div>
				</div>
				<div className="AddJob_main_ProfileInfo">
					<div className="AddJob_main_ProfileInfo_sub">
						<div className="AddJob_main_Profile_sub">
							<Checkbox
								icon={<CheckBoxOutlineBlankIcon style={{ color: "#0275B1", border: 1 }} />}
								checkedIcon={<CheckBoxIcon style={{ color: "#0275B1", border: 1 }} />}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 40,
										borderRadius: 50,
									}
								}}
								checked={inputs.currentSalary}
							/>

						</div>
						<div className="AddJob_main_Profile_sub2">Current Salary</div>
					</div>
					<div>
						<input type="checkbox" id="toggle-checkbox-circle-text" className="toggle__checkbox"
							checked={inputs.currentSalary}
							onChange={(e) => handleOnChange("currentSalary", e.target.checked)}
						/>
						<label htmlFor="toggle-checkbox-circle-text" className="toggle__wrap  toggle__circle">
							<label htmlFor="toggle-checkbox-circle-text" className="toggle__label  toggle__circle  toggle__text"></label>
						</label>
					</div>
				</div>
				<div className="AddJob_main_ProfileInfo">
					<div className="AddJob_main_ProfileInfo_sub">
						<div className="AddJob_main_Profile_sub">
							<Checkbox
								icon={<CheckBoxOutlineBlankIcon style={{ color: "#0275B1", border: 1 }} />}
								checkedIcon={<CheckBoxIcon style={{ color: "#0275B1", border: 1 }} />}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 40,
										borderRadius: 50,
									}
								}}
								checked={inputs.expectedSalary}
							/>

						</div>
						<div className="AddJob_main_Profile_sub2">Expected Salary</div>
					</div>
					<div>
						<input type="checkbox" id="toggle-expectedsalary" className="toggle__checkbox"
							checked={inputs.expectedSalary}
							onChange={(e) => handleOnChange("expectedSalary", e.target.checked)} />
						<label htmlFor="toggle-expectedsalary" className="toggle__wrap  toggle__circle">
							<label htmlFor="toggle-expectedsalary" className="toggle__label  toggle__circle  toggle__text"></label>
						</label>
					</div>
				</div>
				<div className="AddJob_main_ProfileInfo">
					<div className="AddJob_main_ProfileInfo_sub">
						<div className="AddJob_main_Profile_sub">
							<Checkbox
								icon={<CheckBoxOutlineBlankIcon style={{ color: "#0275B1", border: 1 }} />}
								checkedIcon={<CheckBoxIcon style={{ color: "#0275B1", border: 1 }} />}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 40,
										borderRadius: 50,
									}
								}}
								checked={inputs.totalWorkExperience}
							/>

						</div>
						<div className="AddJob_main_Profile_sub2">Total Work Experience</div>
					</div>
					<div>
						<input type="checkbox" id="toggle-totalworkexperience" className="toggle__checkbox"
							checked={inputs.totalWorkExperience}
							onChange={(e) => handleOnChange("totalWorkExperience", e.target.checked)} />
						<label htmlFor="toggle-totalworkexperience" className="toggle__wrap  toggle__circle">
							<label htmlFor="toggle-totalworkexperience" className="toggle__label  toggle__circle  toggle__text"></label>
						</label>
					</div>
				</div>
				<div className="AddJob_main_ProfileInfo">
					<div className="AddJob_main_ProfileInfo_sub">
						<div className="AddJob_main_Profile_sub">
							<Checkbox
								icon={<CheckBoxOutlineBlankIcon style={{ color: "#0275B1", border: 1 }} />}
								checkedIcon={<CheckBoxIcon style={{ color: "#0275B1", border: 1 }} />}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 40,
										borderRadius: 50,
									}
								}}
								checked={inputs.relevantWorkExperience}
							/>

						</div>
						<div className="AddJob_main_Profile_sub2">Relevant Work Experience</div>
					</div>
					<div>
						<input type="checkbox" id="toggle-relevantworkexperience" className="toggle__checkbox"
							checked={inputs.relevantWorkExperience}
							onChange={(e) => handleOnChange("relevantWorkExperience", e.target.checked)}
						/>
						<label htmlFor="toggle-relevantworkexperience" className="toggle__wrap  toggle__circle">
							<label htmlFor="toggle-relevantworkexperience" className="toggle__label  toggle__circle  toggle__text"></label>
						</label>
					</div>
				</div>
				<div className="AddJob_main_ProfileInfo">
					<div className="AddJob_main_ProfileInfo_sub">
						<div className="AddJob_main_Profile_sub">
							<Checkbox
								icon={<CheckBoxOutlineBlankIcon style={{ color: "#0275B1", border: 1 }} />}
								checkedIcon={<CheckBoxIcon style={{ color: "#0275B1", border: 1 }} />}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 40,
										borderRadius: 50,
									}
								}}
								checked={inputs.reasonForJobChange}
							/>

						</div>
						<div className="AddJob_main_Profile_sub2">Reason For Job Change</div>
					</div>
					<div>
						<input type="checkbox" id="toggle-reasonforjobchange" className="toggle__checkbox"
							checked={inputs.reasonForJobChange}
							onChange={(e) => handleOnChange("reasonForJobChange", e.target.checked)} />
						<label htmlFor="toggle-reasonforjobchange" className="toggle__wrap  toggle__circle">
							<label htmlFor="toggle-reasonforjobchange" className="toggle__label  toggle__circle  toggle__text">
							</label>
						</label>
					</div>
				</div>
				<div className="AddJob_main_ProfileInfo">
					<div className="AddJob_main_ProfileInfo_sub">
						<div className="AddJob_main_Profile_sub">
							<Checkbox
								icon={<CheckBoxOutlineBlankIcon style={{ color: "#0275B1", border: 1 }} />}
								checkedIcon={<CheckBoxIcon style={{ color: "#0275B1", border: 1 }} />}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 40,
										borderRadius: 50,
									}
								}}
								checked={inputs.noticePeriod}
							/>

						</div>
						<div className="AddJob_main_Profile_sub2">Notice Period (in days)</div>
					</div>
					<div>
						<input type="checkbox" id="toggle-noticeperiod" className="toggle__checkbox"
							checked={inputs.noticePeriod}
							onChange={(e) => handleOnChange("noticePeriod", e.target.checked)} />
						<label htmlFor="toggle-noticeperiod" className="toggle__wrap  toggle__circle">
							<label htmlFor="toggle-noticeperiod" className="toggle__label  toggle__circle  toggle__text"></label>
						</label>
					</div>
				</div>
				<div className="AddJob_main_ProfileInfo">
					<div className="AddJob_main_ProfileInfo_sub">
						<div className="AddJob_main_Profile_sub">
							<Checkbox
								icon={<CheckBoxOutlineBlankIcon style={{ color: "#0275B1", border: 1 }} />}
								checkedIcon={<CheckBoxIcon style={{ color: "#0275B1", border: 1 }} />}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 40,
										borderRadius: 50,
									}
								}}
								checked={inputs.location}
							/>

						</div>
						<div className="AddJob_main_Profile_sub2">Location</div>
					</div>
					<div>
						<input type="checkbox" id="toggle-location" className="toggle__checkbox"
							checked={inputs.location}
							onChange={(e) => handleOnChange("location", e.target.checked)} />
						<label htmlFor="toggle-location" className="toggle__wrap  toggle__circle">
							<label htmlFor="toggle-location" className="toggle__label  toggle__circle  toggle__text"></label>
						</label>
					</div>
				</div>
			</div>
		</div >
	)
}

export default ProfileInfo